import {setProps, delProps, arrayTobject, normalizeRelations, resolveRelations } from "@/utils";

const makeModule = ({ normalizeRelations = x => x, resolveRelations = x => x, service } = {}) => ({
    namespaced: true,
    state: () => ({allIds: [], byId: {}}),
    getters: {
        find: state => id => resolveRelations(state.byId[id]), // Swap ID referenes with the resolved objects.
        list: (state, getters) => state.allIds.map(id => getters.find(id)), // Return a list of items in the order of `allIds`.
    },
    mutations: {
        insert: (state, item) => {
            state.byId = { ...state.byId, [item.id]: item }; //state.byId[item.id] = item; //Vue.set(state.byId, item.id, item);
            if (state.allIds.includes(item.id)) return;
            state.allIds.push(item.id);
        },
        remove: (state, item) => {
            delete state.byId[item]; //Vue.delete(state.byId, item.id);
            if (state.allIds.includes(item))
                state.allIds.splice(state.allIds.indexOf(item), 1);
        },
    },
    actions: {
        add: async (context, obj) => {
            const item =  await (context.getters.find(obj.id) ? service.update(obj) : service.create(obj));
            context.commit("insert", normalizeRelations(item));
        },
        all: async ({ commit }, obj = {}) => {
            if (!service) throw new Error("No service specified!");// It is not strictly necessary to pass a service, but if none was passed, no data can be loaded.
            const { data } = await service.findAll({params: obj});
            data.forEach(item => commit("insert", normalizeRelations(item)));
            return data; // Noramlize nested data and swap the related objects in the API response with an ID reference.
        },
        one: async (context, id) => {
            return context.getters.find(id) ? context.getters.find(id) :
                await service.findOne(id).then(({ data }) => context.commit("insert", normalizeRelations(data)));
        },
        del: async (context, obj) => {
            if (context.getters.find(obj.id))
                service.remove(obj.id).then(
                    () => context.commit("remove", normalizeRelations(obj.id))
                );
        },
        delete: async (context, id) => {
            if (context.getters.find(id))
                return service.remove(id).then(() => context.commit("remove", id));
        }
    },
});

export const makeModules = ({ normalizeRelations = x => x, resolveRelations = x => x, service } = {}) => ({
    namespaced: true,
    state: () => ({all: {number: 1, content: {}}, alls:[]}),
    getters: {
        find: state => id => resolveRelations(state.all.content[id]), // Swap ID referenes with the resolved objects.
        list: state => state.all, // Return a list of items in the order of `allIds`.
        lists: state => state.alls
    },
    mutations: {
        fetch: (state, item) => state.all = item,
        insert: (state, item) => setProps(state.all,['content',item.id], item),
        remove: (state, item) => delProps(state.all.content, [item.id]),
        fetchAll: (state, item) => state.alls = item
    },
    actions: {
        add: async (context, obj) => {
            const item =  await (context.getters.find(obj.id) ?
                service.update(obj, {partial: obj.patch}) : service.create(obj));
            //context.commit("insert", normalizeRelations(item));
            return item;
        },
        allData: async (context, obj = {}) => {
            const { data } = await service.findAllData({params: obj});
            context.commit("fetch", data)
            return data;
        },
        allComming: async (context, obj = {}) => {
            const { data } = await service.findAllComming({params: obj});
            context.commit("fetch", data)
            return data;
        },
        all: async (context, obj = {}) => {
            const { data } = await service.findAll({params: obj});
            context.commit("fetch", {
                loaded: true, ...data, number: data.number+1,
                content: arrayTobject(data.content)
            })
            return data;
        },
        allPage: async (context, obj = {}) => {
            const { data } = await service.findAllData({params: obj});
            context.commit("fetch", {
                loaded: true, ...data, number: data.number+1,
                content: arrayTobject(data.content)
            })
            return data;
        },
        allAll: async (context, obj = {}) => {
            const { data } = await service.findAll({params: obj});
            context.commit("fetchAll", data);
            return data;
        },
          allR: async (context, obj = {}) => {
            const { data } = await service.findAll({params: obj});
            context.commit("fetch", {
                loaded: true, ...data, number: data.number+1,
                content: data.content
            }) // Noramlize nested data and swap the related objects in the API response with an ID reference.
        },
        one: async (context, id) => {
            return context.getters.find(id) ? context.getters.find(id) :
                await service.findOne(id).then(({ data }) => {
                    context.commit("insert", normalizeRelations(data));
                    return data;
                });
        },
        del: async (context, id) => {
            if (context.getters.find(id))
                return service.remove(id).then(() => context.commit("remove", id));
        },
    },
});

export const makeIt = ({ normalizeRelations = x => x, service } = {}) => ({
    namespaced: true,
    state: () => ({all: []}),
    getters: {
        find: state => id => state.all[id], // Swap ID referenes with the resolved objects.
        list: state => state.all, // Return a list of items in the order of `allIds`.
    },
    mutations: {
        fetch: (state, item) => state.all = item,
        insert: (state, item) => setProps(state.all,['content',item.id], item),
        remove: (state, item) => delProps(state.all.content, [item.id])
    },
    actions: {
        add: async (context, obj) => {
            /*const item =  await (context.getters.find(obj.id) ?
                service.update(obj, {partial: obj.patch}) : service.create(obj));
            //context.commit("insert", normalizeRelations(item));
            return item;*/
            const item =  await service.create(obj);
            return item;
        },
        save: async (context, obj) => {
            const item =  await service.save(obj);
            return item;
        },
        update: async (context, obj) => {
            /*const item =  await (context.getters.find(obj.id) ?
                 : service.create(obj));
            //context.commit("insert", normalizeRelations(item));
            return item;*/
            const item =  await service.update(obj, {partial: obj.patch});
            return item;
        },
        all: async (context, obj = {}) => {
            const { data } = await service.findAll({params: obj});
            // context.commit("fetch", {
            //     loaded: true, ...data, number: data.number+1,
            //     content: data.content
            // })
            context.commit("fetch", data)
            return data;
        },
        allPage: async (context, obj = {}) => {
            const { data } = await service.findAll({params: obj});
             context.commit("fetch", {
                 loaded: true, ...data, number: data.number+1,
                 content: data.content
             })
            context.commit("fetch", data)
            return data;
        },
        allAgent: async (context, obj = {}) => {
            const { data } = await service.findAllAgent({params: obj});
            context.commit("fetch", {
                loaded: true, ...data, number: data.number+1,
                content: data.content
            })
            return data;
        },
        allByMatricule: async (context, obj = {}) => {
            const account = JSON.parse(localStorage.getItem("gesproAccount")) || {};
            const { data } = await service.findAllMatricule({params: obj}, account?.matricule);
            context.commit("fetch", {
                loaded: true, ...data, number: data.number+1,
                content: data.content
            })
            return data;
        },
          allR: async (context, obj = {}) => {
            const { data } = await service.findAll({params: obj});
            context.commit("fetch", data) // Noramlize nested data and swap the related objects in the API response with an ID reference.
        },
        one: async (context, id) => {
            return context.getters.find(id) ? context.getters.find(id) :
                await service.findOne(id).then(({ data }) => {
                    context.commit("insert", normalizeRelations(data));
                    return data;
                });
        },
        del: async (context, id) => {
            if (context.getters.find(id))
                return service.remove(id).then(() => context.commit("remove", id));
        }
    },
});

export default makeModule;